import type { ReactNode } from "react";
import { AlertTriangle, CheckCircle2, Info, ShieldAlert } from "lucide-react";
import { cn } from "../lib/cn";

const tones = {
  info: {
    icon: Info,
    className: "border-cyan-400/15 bg-cyan-500/[0.06] text-cyan-100",
    iconClassName: "text-cyan-300",
  },
  warning: {
    icon: AlertTriangle,
    className: "border-amber-400/15 bg-amber-500/[0.07] text-amber-100",
    iconClassName: "text-amber-300",
  },
  error: {
    icon: ShieldAlert,
    className: "border-rose-400/15 bg-rose-500/[0.07] text-rose-100",
    iconClassName: "text-rose-300",
  },
  success: {
    icon: CheckCircle2,
    className: "border-emerald-400/15 bg-emerald-500/[0.06] text-emerald-100",
    iconClassName: "text-emerald-300",
  },
} as const;

export function Alert({
  tone = "info",
  title,
  children,
  className,
}: {
  tone?: keyof typeof tones;
  title?: string;
  children?: ReactNode;
  className?: string;
}) {
  const config = tones[tone];
  const Icon = config.icon;
  return (
    <div
      className={cn(
        "flex gap-3 rounded-xl border px-3.5 py-3 text-[13px] leading-relaxed",
        config.className,
        className,
      )}
      role={tone === "error" ? "alert" : "status"}
    >
      <Icon className={cn("mt-0.5 size-4 shrink-0", config.iconClassName)} />
      <div className="min-w-0">
        {title && <p className="font-medium">{title}</p>}
        {children && (
          <div className={cn(title && "mt-0.5 opacity-80")}>{children}</div>
        )}
      </div>
    </div>
  );
}
